define(function (require, exports) {
    'use strict';

    // @ngInject
    exports.includeExcludeBox = function (TEMPLATE_PATH) {
        return {
            restrict: 'E',
            controller: /* @ngInject */ function ($scope, $element, $log) {
                $scope.mainCtrl.includedItems = {};
                $scope.mainCtrl.excludedItems = {};
                $scope.mainCtrl.includeAll = false;
                $scope.mainCtrl.excludeAll = false;
                $scope.mainCtrl.actionType = null;

                $log.log($scope.readOnly);

                /**
                 * _containsObj()
                 * Verify if the array
                 * contains account
                 */
                var containsObj = function (obj, list) {
                    var i;
                    for (i = 0; i < list.length; i++) {
                        if (obj.name === list[i].name && obj.id === list[i].id) {
                            return true;
                        }
                    }
                    return false;
                };

                /**
                 * _categoriseItem()
                 * INC or EXC
                 * account
                 */
                var categoriseItem = function (item, isInclude) {
                    var list = isInclude ? $scope.mainCtrl.includedItems : $scope.mainCtrl.excludedItems;
                    var bucket = list[item.typeDescription] || [];

                    if (isInclude) {
                        $scope.mainCtrl.actionType = 'INC';
                    } else {
                        $scope.mainCtrl.actionType = 'EXC';
                    }

                    if (!$scope.isCategory) {
                        if (!containsObj(item, bucket)) {
                            bucket.push(item);
                            list[item.typeDescription] = bucket;
                        }
                    }
                    else {
                        $scope.create.accountGroup.typeAction.push({
                            actionType: $scope.mainCtrl.actionType,
                            accountType: item.id
                        });

                        list[item.description] = 1;
                    }
                };

                window.gadgets.pubsub.subscribe('category', function () {
                    $scope.isCategory = true;
                });

                window.gadgets.pubsub.subscribe('account', function () {
                    $scope.isCategory = false;
                });

                /**
                 * $scope.inclExclItem
                 * INC or EXC
                 * account calling _categoriseItem()
                 */
                $scope.mainCtrl.inclExclItem = function (inclFlag) {
                    categoriseItem($scope.mainCtrl.selectedAccItem, !!inclFlag);
                    $scope.$emit('item-list-changed');
                };

                /**
                 * $scope.inclExclAll
                 * INC or EXC
                 * ALL accounts
                 */
                $scope.mainCtrl.inclExclAll = function (inclFlag) {
                    $scope.mainCtrl.includedItems = {};
                    $scope.mainCtrl.excludedItems = {};

                    if (inclFlag && $scope.mainCtrl.includeAll) {
                        $scope.create.accountGroup.typeAction = [];

                    } else if (inclFlag && !$scope.mainCtrl.includeAll) {
                        $scope.create.accountGroup.typeAction = [{
                            actionType: 'ALL',
                            accountType: null
                        }];
                    } else if (!inclFlag && $scope.mainCtrl.excludeAll) {
                        $scope.create.accountGroup.typeAction = [];

                    } else if (!inclFlag && !$scope.mainCtrl.excludeAll) {
                        $scope.create.accountGroup.typeAction = null;
                    }
                    $scope.$emit('item-list-changed');
                };

                /**
                 * $scope.removeCategory
                 * Remove category
                 */
                $scope.mainCtrl.removeCategory = function (category, inclFlag) {
                    var items = inclFlag ? $scope.mainCtrl.includedItems : $scope.mainCtrl.excludedItems;

                    for (var key in items) {
                        if (key === category) {
                            delete items[key];
                            $scope.$emit('item-list-changed');
                            return;
                        }
                    }
                };

                /**
                 * $scope.removeItem
                 * Remove account
                 */
                $scope.mainCtrl.removeItem = function (category, index, inclFlag) {
                    // remove item and check if the included or excluded list has no items
                    // for that category in order to delete it
                    if (inclFlag) {
                        $scope.mainCtrl.includedItems[category].splice(index, 1);

                        if ($scope.mainCtrl.includedItems[category].length === 0) {
                            delete $scope.mainCtrl.includedItems[category];
                        }
                    } else {
                        $scope.mainCtrl.excludedItems[category].splice(index, 1);

                        if ($scope.mainCtrl.excludedItems[category].length === 0) {
                            delete $scope.mainCtrl.excludedItems[category];
                        }
                    }
                    $scope.$emit('item-list-changed');
                };
            },
            templateUrl: TEMPLATE_PATH + 'includeExcludeBox.html'
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/includeExcludeBox.js